<template>
  <div class="sidebar-pinned ">
    <Navbar/>

    <main class="admin-main">
    <!--site header begins-->

   <section class="admin-content">
        <div class="container">

            <div class="row">
                <div class="col-12 m-b-20">
                    <!-- <h5 class="spacer-top">Hello, </h5> -->
                </div>

              <div class="row col-md-12"  v-if="myplan.message == 'Customer retrieved'">
                <div class="col-md-6">
                  <div class="alert alert-border-success  alert-dismissible fade show" role="alert">
                                  <div class="d-flex">
                                      <div class="icon">
                                          <i class="icon mdi mdi-check-circle"></i>
                                      </div>
                                      <div class="content" v-for ="sub in myplan.data.subscriptions" v-bind:key="sub.id">
                                        <p>  <strong>{{sub.status}}</strong></p>
                                        <p> &#8358;<strong>{{sub.amount/100 | numeral (0,0)}}</strong> </p>
                                          <p> <strong>Next Payment:</strong> {{sub.next_payment_date}}</p>
                                      </div>
                                  </div>
                              </div>
                </div>
              </div>

              <div class="row col-md-12"  v-if="myplan.message == 'Customer not found'">
                <div class="col-md-6">
                  <div class="alert alert-border-warning  alert-dismissible fade show" role="alert">
                                  <div class="d-flex">
                                      <div class="icon">
                                          <i class="icon mdi mdi-alert-circle-outline"></i>
                                      </div>
                                      <div class="content" >
                                      <a href="/subscribe">  <p>  <strong>Click to Subscribe to a Plan</strong></p> </a>
                                      </div>
                                  </div>
                              </div>
                </div>
              </div>

                <div class="col-lg-4 col-md-6">
                    <div class="card m-b-30">
                        <div class="card-body">
                            <div class="pb-2">
                              <!-- <router-link :to="{ path: '/my-funds'}"> -->
                                <div class="avatar avatar-lg">
                                    <div class="avatar-title bg-soft-primary rounded-circle">
                                        <i class="fe fe-database"></i>
                                    </div>
                                </div>
                              <!-- </router-link> -->
                            </div>
                            <div>
                                <p class="text-muted text-overline m-0">Kogi State Health Insurance Agency</p>
                                <h1 class="fw-400"> <strong> {{user.firstname}} {{user.lastname}}</strong></h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="card m-b-30">
                        <div class="card-body">
                            <div class="pb-2">
                              <!-- <router-link :to="{ path: '/my-dependents'}"> -->
                                <div class="avatar avatar-lg">
                                    <div class="avatar-title bg-soft-primary rounded-circle">
                                        <i class="fe fe-users"></i>
                                    </div>
                                </div>
                              <!-- </router-link> -->
                            </div>
                            <div>
                                <p class="text-muted text-overline m-0">Dependents</p>
                                <h1 class="fw-400">{{dependents.length}}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6" >
                    <div class="card m-b-30">
                        <div class="card-body">
                            <div class="pb-2">
                              <!-- <router-link :to="{ path: '/subscribe'}"> -->
                                <div class="avatar avatar-lg">
                                    <div class="avatar-title bg-soft-primary rounded-circle">
                                        <i class="fe fe-credit-card"></i>
                                    </div>
                                </div>
                              <!-- </router-link> -->
                            </div>
                            <div>
                                <p class="text-muted text-overline m-0">Plan</p>
                                <h1 class="fw-400"  >{{user.sector}} </h1>
                                <!-- <p v-if="myplan.length < 1">No active Subscription</p> -->
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-12 m-b-30">
                    <h5> <i class="fe fe-users"></i> Dependents</h5>
                    <div class="table-responsive">
                        <table class="table align-td-middle table-card">
                            <thead>
                            <tr>
                                <!-- <th>Avatar</th> -->
                                <th>Name</th>
                                <th>E mail</th>
                                <th>Phone Number</th>
                                <th>Relationship</th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="dependent in dependents" v-bind:key="dependent.id">
                                <!-- <td>
                                    <div class="avatar avatar-sm "><img src="assets/img/users/user-1.jpg"
                                                                        class="avatar-img avatar-sm rounded-circle"
                                                                        alt=""></div>
                                </td> -->
                                <td><router-link :to="{ path: '/dependent/' + dependent.id }">{{dependent.firstname}} {{dependent.lastname}}</router-link></td>
                                <td>{{dependent.email}}</td>
                                <td>{{dependent.phone_number}}</td>
                                <td>{{dependent.relationShipType}}</td>

                            </tr>


                            </tbody>
                        </table>

                    </div>
                </div>
                <!-- <div class="col-md-12 m-b-30">
                    <h5> <i class="fe fe-alert-circle"></i> Complaints</h5>
                    <div class="table-responsive">
                        <table class="table align-td-middle table-card">
                            <thead>
                            <tr>
                                <th>Complain Number</th>
                                <th>Title</th>
                                <th>Type</th>
                                <th>Status</th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="complaint in complaints" v-bind:key="complaint.id">
                              <td>122333932</td>
                                <td>{{complaint.title}}</td>
                                <td>{{complaint.type}}</td>
                                <td>{{complaint.status}}</td>
                            </tr>

                            </tbody>
                        </table>

                    </div>
                </div> -->

            </div>
        </div>

    </section>
</main>


    </div>

</template>

<script>
import Navbar from '@/views/Navbar.vue'

export default {
  components: {
     Navbar
  },
  data(){
    return{
      auth_user:"",
      dependents:"",
      myplan:"",
      wallet:"",
      complaints:"",
      subscription:"",
      user:null

    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/user/${this.user.id}`)
                .then(response => {
                    this.auth_user = response.data.user
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{

    getDependents(){
      this.user = JSON.parse(localStorage.getItem('user'))

      this.axios.get(`/api/v1/auth/allDependantUser/${this.user.id}`)
                  .then(response => {
                      this.dependents = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    getPlan(){
      this.user = JSON.parse(localStorage.getItem('user'))
    fetch(`https://api.paystack.co/customer/${this.user.email}`,{
        method: "GET",
        headers: {
          "Content-Type":"application/json",
          "Authorization": "Bearer sk_test_0a0b5d9bd6106a0436f9028feb6f808cbbc23718"}
      })
                  // .then(response => {
                  //     this.myplan = response.data
                  //     console.log(response)
                  // })
                  // .catch(error => {
                  //     console.error(error);
                  // })

                  .then(response => response.json())
                  .then(data => (this.myplan = data));
    },



  },
  created(){
    this.getDependents()
    this.getPlan()
  }
}
</script>
<style lang="css" scoped>
  .spacer-top{
    margin-top:10px;
  }
</style>
